import { ChatBubbleLeftIcon, PhoneArrowUpRightIcon } from "@heroicons/react/24/outline";
import { PanelType } from "components/ui/panel/panel-type";
import { ResponsivePanel } from "components/ui/panel/responsive-panel";
import React from "react";
import { ContactValueIcon } from "./display-row";

const chooserRowClasses =
    "flex items-center gap-3 rounded-md border border-gray-200 px-4 py-3 text-gray-900 hover:bg-gray-50";

interface PhoneChooserRowProps {
    Icon: ContactValueIcon;
    text: string;
    open: () => void;
}

const PhoneChooserRow: React.FC<PhoneChooserRowProps> = props => {
    const { Icon, text, open } = props;

    const handleClick = React.useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            e.stopPropagation();
            open();
        },
        [open],
    );

    return (
        <a href="#" className={chooserRowClasses} onClick={handleClick}>
            <Icon className="h-5 w-5 flex-shrink-0 text-gray-500" aria-hidden="true" />
            <span>{text}</span>
        </a>
    );
};

interface PhoneChooserPanelProps {
    isOpen: boolean;
    onDismiss: () => void;
    display: string;
    onCall: () => void;
    onText: () => void;
}

export const PhoneChooserPanel: React.FC<PhoneChooserPanelProps> = props => {
    const { isOpen, onDismiss, display, onCall, onText } = props;

    return (
        <ResponsivePanel
            isOpen={isOpen}
            onDismiss={onDismiss}
            type={PanelType.smallFluid}
            headerText={display}>
            <div className="space-y-3">
                <PhoneChooserRow
                    Icon={PhoneArrowUpRightIcon}
                    text={`Call ${display}`}
                    open={onCall}
                />
                <PhoneChooserRow
                    Icon={ChatBubbleLeftIcon}
                    text={`Text ${display}`}
                    open={onText}
                />
            </div>
        </ResponsivePanel>
    );
};
